export default "__VITE_ASSET__1b25e4b3__"